import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
import styles from 'pages/digital-tools/logistics-explorer/LogisticsExplorer.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/DigitalTools/LogisticsExplorer/components/SectionHeader'));
const SectionAbout = dynamic(() => import('sections/DigitalTools/LogisticsExplorer/components/SectionAbout'));
const SectionVideo = dynamic(() => import('sections/DigitalTools/LogisticsExplorer/components/SectionVideo'));
const SectionFeatures = dynamic(() => import('sections/DigitalTools/LogisticsExplorer/components/SectionFeatures'));
const SectionWidgets = dynamic(() => import('sections/DigitalTools/LogisticsExplorer/components/SectionWidgets'));
const SectionCallToAction = dynamic(() => import('sections/DigitalTools/LogisticsExplorer/components/SectionCallToAction'));
const SectionFaq = dynamic(() => import('sections/DigitalTools/LogisticsExplorer/components/SectionFaq'));

export default function LogisticsExplorer(): ReactElement {
  return (
    <div className={cn('logistics-explorer')}>
      <SectionHeader />
      <SectionAbout />
      <SectionVideo />
      <SectionFeatures />
      <SectionWidgets />
      <SectionCallToAction />
      <SectionFaq />
    </div>
  );
};

export const getStaticProps = async () => {
  return {
    props: {
      title: 'Cargo Freight Calculator | Logistics Explorer | DF Alliance',
      description: 'Promote your freight rates, generate hot shipping leads, and grow your business with DF Alliance. Logistics Explorer helps forwarders to engage shippers and boost global coverage of tariffs.',
      path: '/digital-tools/logistics-explorer',
    },
  };
};

LogisticsExplorer.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
